import React, { useEffect, useState } from 'react';
import api from '../api';
import SocialIcon from './SocialIcon';
import { useAuthContext } from '../auth/AuthContext';

export default function SocialLoginButtons({ busy = false, registration = false, consent = null, onError }) {
    const context = useAuthContext();
    const [providers, setProviders] = useState([]);
    const [starting, setStarting] = useState(false);
    useEffect(() => {
        let active = true;
        api.get('/api/auth/social-providers').then(({ data }) => { if (active) setProviders(data); }).catch(() => { if (active) setProviders([]); });
        return () => { active = false; };
    }, []);
    if (!providers.length) return null;
    const disabled = busy || starting || (registration && !consent);
    const begin = async provider => {
        if (disabled) return;
        setStarting(true);
        try {
            await api.get('/api/auth/csrf');
            const { data } = await api.post('/api/auth/social-registration/start', { provider: provider.id, agreements: consent });
            window.location.assign(data.targetUrl);
        } catch (error) {
            onError?.(error.response?.data?.detail || error.response?.data?.message || 'Не удалось начать регистрацию. Обновите документы и попробуйте снова.');
            setStarting(false);
        }
    };
    return <div className="auth-social"><div className="auth-divider">или</div><div className="auth-social-list">
        {providers.map(provider => registration
            ? <button key={provider.id} type="button" disabled={disabled} onClick={() => begin(provider)} className={`auth-social-button provider-${provider.id}`}><SocialIcon provider={provider.id} size={22} />{starting ? 'Продолжаем…' : `Войти с ${provider.name}`}</button>
            : <a key={provider.id} href={provider.authorizationUrl + (context.flow ? '?flow=' + encodeURIComponent(context.flow) : '')} aria-disabled={disabled} tabIndex={disabled ? -1 : undefined} onClick={event => { if (disabled) event.preventDefault(); }} className={`auth-social-button provider-${provider.id}`}><SocialIcon provider={provider.id} size={22} />Войти с {provider.name}</a>)}
    </div></div>;
}
